// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // envName: "Prod",
  envName: "",
  dbPrefix: "",
  pg_dburl: {
    "http://localhost:4200":
      "http://localhost:3060/pgrest",
    "https://mc0-safecab-app.dev.apps.renault.com":
      "https://mc0-safecab-api.dev.apps.renault.com/pgrest",
    "https://mc0-safecab-app.int.apps.renault.com":
      "https://mc0-safecab-api.int.apps.renault.com/pgrest",
    "https://mc0-safecab-app.ope.apps.renault.com":
      "https://mc0-safecab-api.ope.apps.renault.com/pgrest",
  },
  snsurl: "https://preprod-sms.rntbciconnect.com/token",
  firebase: {
    apiKey: "AIzaSyBfEKUcykzjyMHIUbNZbH4NCTLeIHg7UpI",
    authDomain: "cabtrack-6cb6e.firebaseapp.com",
    databaseURL: "https://cabtrack-6cb6e.firebaseio.com",
    projectId: "cabtrack-6cb6e",
    storageBucket: "cabtrack-6cb6e.appspot.com",
    messagingSenderId: "523233495121",
  },
  // Stagging w - preprod
  myAppConfig: {
    aws_appsync_graphqlEndpoint:
      "https://w4tjgxrxvnguldsclbiqylytm4.appsync-api.ap-south-1.amazonaws.com/graphql",
    aws_appsync_region: "ap-south-1",
    aws_appsync_authenticationType: "API_KEY",
    aws_appsync_apiKey: "da2-fagrx6qwjvcgxfq4pywmllx3xa", //"da2-xi2l46vzbrgkpgjgofklofst4m", // "da2-4v2apg77jvgnjpkvyvh4lkxebi"// "da2-qcuqmnkwyrev7pxws67x7gkh7a"
  },
  mySafeCabURL: "https://preprod-safecab.rntbciconnect.com/",
  AWSS3BucketCredentials: {
    accessKeyId: "AKIA5NIG4PFNJ6NPFS7G",
    secretToken: "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",
    region: "ap-south-1",
    bucketName: "rnconnect-ope",
  },

  //emailUrl: 'https://preprod-sms.rntbciconnect.com/email',
  //smsUrl: 'https://preprod-sms.rntbciconnect.com',
  emailUrl: {
    "https://mc0-safecab-app.dev.apps.renault.com":
      "https://mc0-safecab-api.dev.apps.renault.com/email",
    "https://mc0-safecab-app.int.apps.renault.com":
      "https://mc0-safecab-api.int.apps.renault.com/email",
    "https://mc0-safecab-app.ope.apps.renault.com":
      "https://mc0-safecab-api.ope.apps.renault.com/email",
  },
  smsUrl: {
    "http://localhost:4200": "http://localhost:3060",
    "https://mc0-safecab-app.dev.apps.renault.com":
      "https://mc0-safecab-api.dev.apps.renault.com",
    "https://mc0-safecab-app.int.apps.renault.com":
      "https://mc0-safecab-api.int.apps.renault.com",
    "https://mc0-safecab-app.ope.apps.renault.com":
      "https://mc0-safecab-api.ope.apps.renault.com",
  },
  fcmUrl: "https://fcm.googleapis.com/v1/projects/rnconnect--int/messages:send",
  oktaConfig: {
    prompt: "NONE",
    scope: "openid profile email offline_access apis.default",
    responseType: "code",
    issuer: {
      "localhost:4200": "https://dev-23583481.okta.com/oauth2/default",
      "https://mc0-safecab-app.dev.apps.renault.com":
        "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416",
      "https://mc0-safecab-app.int.apps.renault.com":
        "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416",
      "https://mc0-safecab-app.ope.apps.renault.com":
        "https://sso.renault.com/oauth2/aus133y6mks4ptDss417"
    },
    clientsId: {
      "localhost:4200": "0oalscgyl3WdNl8Zf5d7",
      "https://mc0-safecab-app.dev.apps.renault.com":
        "irn-70453_uat_code_8gethoxdze7r",
      "https://mc0-safecab-app.int.apps.renault.com":
        "irn-70453_uat_code_8gethoxdze7r",
      "https://mc0-safecab-app.ope.apps.renault.com":
        "irn-70453_ope_code_cnzku1gcinkt"
    },
    redirectUri: {
      "localhost:4200": "http://localhost:4200/callback",
      "https://mc0-safecab-app.dev.apps.renault.com":
        "https://mc0-safecab-app.dev.apps.renault.com/callback",
      "https://mc0-safecab-app.int.apps.renault.com":
        "https://mc0-safecab-app.int.apps.renault.com/callback",
      "https://mc0-safecab-app.ope.apps.renault.com":
        "https://mc0-safecab-app.ope.apps.renault.com/callback"
    },
    loginUrl: {
      "localhost:4200": "https://dev-23583481.okta.com/oauth2/default/v1/authorize",
      "https://mc0-safecab-app.dev.apps.renault.com":
        "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416/v1/authorize",
      "https://mc0-safecab-app.int.apps.renault.com":
        "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416/v1/authorize",
      "https://mc0-safecab-app.ope.apps.renault.com":
        "https://sso.renault.com/oauth2/aus133y6mks4ptDss417/v1/authorize"
    },
    oktaLogoutUrl: {
      "localhost:4200": "https://dev-23583481.okta.com/oauth2/default/v1/logout",
      "https://mc0-safecab-app.dev.apps.renault.com":
        "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416/v1/logout",
      "https://mc0-safecab-app.int.apps.renault.com":
        "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416/v1/logout",
      "https://mc0-safecab-app.ope.apps.renault.com":
        "https://sso.renault.com/oauth2/aus133y6mks4ptDss417/v1/logout"
    },
    postLogoutRedirectUri: {
      "localhost:4200": "http://localhost:4200/logout",
      "https://mc0-safecab-app.dev.apps.renault.com":
        "https://mc0-safecab-app.dev.apps.renault.com/logout",
      "https://mc0-safecab-app.int.apps.renault.com":
        "https://mc0-safecab-app.int.apps.renault.com/logout",
      "https://mc0-safecab-app.ope.apps.renault.com":
        "https://mc0-safecab-app.ope.apps.renault.com/logout"
    }
  },
};

// export const environment = {
//   production: true,
//   envName: "Prod",
//   dbPrefix: "Prod",
//   enableLogging: true ,
//   // envName: "",
//   snsurl: "https://safecab-sms.rntbciconnect.com/token",
//   firebase: {
//     apiKey: "AIzaSyBfEKUcykzjyMHIUbNZbH4NCTLeIHg7UpI",
//     authDomain: "cabtrack-6cb6e.firebaseapp.com",
//     databaseURL: "https://cabtrack-6cb6e.firebaseio.com",
//     projectId: "cabtrack-6cb6e",
//     storageBucket: "cabtrack-6cb6e.appspot.com",
//     messagingSenderId: "523233495121",
//   },

//   // Production
//   myAppConfig: {
//     // ...
//     aws_appsync_graphqlEndpoint:
//       "https://kufslz7ccfddlhnyj7fbngmozi.appsync-api.ap-south-1.amazonaws.com/graphql",
//     aws_appsync_region: "ap-south-1",
//     aws_appsync_authenticationType: "API_KEY",
//     aws_appsync_apiKey: "da2-vhw5yvsnvfap5gjm6zaxo6ns2a", //'da2-xej2cau5jvdw5dqrqsozfpdknq'
//   },
//   mySafeCabURL: "https://safecab.rntbciconnect.com/",

//   AWSS3BucketCredentials: {
//     accessKeyId: 'AKIA5NIG4PFNJ6NPFS7G',
//     secretToken: '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',
//     region: 'ap-south-1',
//     bucketName: 'rnconnect-ope',
//   },
//   emailUrl: 'https://safecab-sms.rntbciconnect.com/email',
//   smsUrl: 'https://safecab-sms.rntbciconnect.com',
//   fcmUrl: 'https://fcm.googleapis.com/v1/projects/rnconnect-ope/messages:send'
// };
